<template>
  <span>
    {{getDisplay}}
    <md-tooltip md-delay="50">{{ tagId }}</md-tooltip>
  </span>
</template>
<script>
  import { mapGetters } from 'vuex';

  export default {
    props: {
      tagId: String,
      group: String
    },
    computed: {
      ...mapGetters([
        'getMasterDataName',
      ]),
      getDisplay() {
        if (!this.tagId) {
          return "";
        }
        return this.getMasterDataName(this.group, this.tagId) || this.tagId;
      }
    },
  }
</script>